module.exports = "/_next/static/images/fairmont-1076fe115fb763a843804d5868c17230.png";